export default __webpack_public_path__ + "static/media/Banner - Artisan - Grey.138ee738.jpg";